import {Card, Image} from "react-bootstrap";
import React from "react";
import {FaGithub} from 'react-icons/fa';

const WebAppCardList = (props) => {
    const {projectList} = props;
    return projectList.map((ele, k) => {
        return <Card key={k} className={'px-4 py-3 mb-3'} style={{fontWeight: 500}}>
            <Image src={ele.embed} fluid/>
            <br/>
            <h4 className={'skill-heading'}>{ele.title}</h4>
            <small>{ele.type}</small>
            {ele.desc}
            <ul className={'list-unstyled d-inline-flex'}>
                { (ele.platforms.length > 0) &&
                    <li className={'mr-3'}>
                        <a href={ele.platforms[0].github}>
                            <FaGithub/>
                        </a>
                    </li>
                }
            </ul>
        </Card>
    })
};

export default WebAppCardList;
